import axios, { Canceler } from 'axios'
import { EnhancedWithAuthHttpService } from './http-auth.service'

import { axiosInstance } from './http-common.service'
import { HttpService } from './http.service'
import {
  ICreateImpactPeriodDto,
  IImpactPeriodChangesRespDto,
  IImpactPeriodsRespDto,
  IMessageResponseDto,
  IUpdateImpactPeriodDto,
} from 'src/types'

class ImpactPeriodService extends EnhancedWithAuthHttpService {
  CancelToken
  cancel?: Canceler
  constructor() {
    super(new HttpService(axiosInstance))
    this.CancelToken = axios.CancelToken
  }

  getImpactPeriods(params?: {}) {
    if (this.cancel) {
      this.cancel()
    }
    return this.get<IImpactPeriodsRespDto>('impact-periods', {
      params,
      cancelToken: new this.CancelToken((c) => {
        this.cancel = c
      }),
    })
  }

  getImpactPeriodChanges(id: string) {
    return this.get<IImpactPeriodChangesRespDto>(`impact-periods/${id}/changes`)
  }

  createImpactPeriod(dto: ICreateImpactPeriodDto) {
    return this.post<IMessageResponseDto, ICreateImpactPeriodDto>('impact-periods', dto)
  }

  updateImpactPeriod({ id, ...dto }: IUpdateImpactPeriodDto) {
    return this.put<IMessageResponseDto, Omit<IUpdateImpactPeriodDto, 'id'>>(
      `impact-periods/${id}`,
      dto,
    )
  }

  updateImpactPeriodsOrder(ids: string[]) {
    return this.put(`impact-periods/order/update`, { ids })
  }

  removeImpactPeriods(ids: string[]) {
    return this.delete<IMessageResponseDto>(`impact-periods`, { data: { ids } })
  }
}

export const impactPeriodService = new ImpactPeriodService()
export default ImpactPeriodService
